import { sponsors }  from './sponsors'
import { seasondefaults } from './seasondefaults'

export const eventdefaults = {
    ...seasondefaults,
    currentWizardStep:1,
    eventRetrieved:false,  
    inWizardMode:false,
    eventId:0,
    fetchingevent:false,
    eventcountry : 'usa',
    directorcountry : 'usa',
    eventseason:'',
    eventInfoIsCorrect:false,
    eventDetailsIsCorrect:false,
    eventtier:'2',
    eventsponsor:sponsors.USBC,
    eventgendermen: true,
    eventgenderwomen: true,
    eventjvgendermen: true,
    eventjvgenderwomen: true,
    eventsamequalifyingformat: "true",
    eventjv:"true",
    eventnumberofdays:'2',
    isoilratiobygender:"false",
    dailyoilratios:"false",
    dailyoilratioswomen:"false",
    dailyoilratiosmen:"false",
    oilratio:{
        "1":{
            men:'',
            women:'',
            single:''
        },
        "2":{
            men:'',
            women:'',
            single:''
        },
        "3":{
            men:'',
            women:'',
            single:''
        } 
    },
    directorname:'',
    directorssoemail:'',
    directorphone:'',
    directoraddress1:'',
    directoraddress2:'',
    directorcity:'',
    directorstate:'',
    directorzipcode:'',
    participantschools:[],
    eventemail:'',
    sorted:false,
    wrongparticipantselection:false,
    hasCheckedTeamSelection:false,
    seasons:[],
    notifyingSchoolNotFound:false,
    schoolNotFoundNotfSent:false,
    isEventInfoVerified:false,
    eventVerificationEmailSent:false,
    isEventDetailsVerified:false,
    schools:[],
    searching:false,
    gettingTeamRosters:false,
    pendinguploads:[],
    uploadingfile:false,
    selectedschool:'',
    hasDirectorRole:true,
    hasAdminRole:false
}


// WEBPACK FOOTER //
// ./src/utils/constants/eventdefaults.js